module.exports = __webpack_public_path__ + "img/rms1.315e4ae6.jpg";